import React from 'react';
import FooterNav from './footer_nav';
import ar from '../languages/ar';
import '../../www/assets/css/vital_signs.css';
import { refsStore, datasetStore, videoStore, poiStore, gmapStore } from '../managers/globalState';

class VitalSigns extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedClass: 'selected'
		};

		// Binds
		this._renderItems = this._renderItems.bind(this);
		this._handleEventSelection = this._handleEventSelection.bind(this);
		this._handlePoISelection = this._handlePoISelection.bind(this);
		this._handleGmapSelection = this._handleGmapSelection.bind(this);
		this.getRelatedVSList = this.getRelatedVSList.bind(this);
		this.scrollToItem = this.scrollToItem.bind(this);
		this.language = ar;
	}

	componentDidMount() {
		this.dsUnsubscribe = datasetStore.subscribeTo('currentVS', () => this.forceUpdate());
		this.videosUnsubscribe = videoStore.subscribeTo('videoId', videoId => {
			const { get } = refsStore.stateSnapshot;
			this.setState({ selectedClass: get('video').getVideoType(videoId) === 'global' ? '' : 'selected' });
		});
	}

	componentWillUnmount() {
		typeof this.dsUnsubscribe === 'function' && this.dsUnsubscribe();
		typeof this.videosUnsubscribe === 'function' && this.videosUnsubscribe();
	}

	_renderItems() {
		const {
			view,
			event,
			poi,
			gmap,
			spacecraft,
			goToVitalView
		} = this.props;
		if (view === 'vitalsign' || view === undefined) {
			const { get } = refsStore.stateSnapshot;
			// This says: establishing a variable vitalList = get('content').vitalList
			const { vitalList, vitalSignId } = get('content');


			// filter out the vital signs that should go into the footer
			const filteredList = vitalList.filter(value => !value.hideFromFooter);
			const { selectedClass } = this.state;

			return filteredList.map((listValue, index) => (

				<li
					key={listValue.id}
					data-value={listValue.value}
					onClick={goToVitalView}
					className={vitalSignId === listValue.value ? selectedClass : ''}
				>
					<a className='list-value'>
						{listValue.title}
					</a>
				</li>
			));
		} else if (view === 'spacecraft') {
			let relatedDatesets = [];
			// Todo: merge this.getRelatedDatasetsList with content manager's getRelatedDatasets - Task #3187.
			relatedDatesets = this.getRelatedDatasetsList(spacecraft);
			// Todo: No datasets currently available looks quite ugly. Perhaps displaying nothing would be better?
			// Is it really relevent to tell the user when there are not any related datasets?
			if (relatedDatesets.length === 0) {
				return ([
					<li
						key='none'
						data-value='none'
					>
						{this.language.no_datasets}
					</li>
				]);
			}
			return relatedDatesets.map(({ datasetId, vitalSignId, altid, title }) => (
				<li
					key={`related-${datasetId}`}
					data-value={vitalSignId}
					data-group={altid}
					onClick={goToVitalView}
				>
					<a className='list-value'>
						{title}
					</a>
				</li>
			));
		} else if (view === 'event') {
			const { get } = refsStore.stateSnapshot;
			const { latestEvents } = get('content');
			const eventsList = [];

			for (let i = 0; i < 3; i++) {
				let styleName = '';
				if (latestEvents[i]) {
					if (event.id === latestEvents[i].external_id) {
						styleName = 'selected';
					}

					eventsList.push(
						<li
							key={latestEvents[i].external_id}
							className={styleName}
							data-value={latestEvents[i].external_id}
							onClick={this._handleEventSelection}
						>
							<a className='list-value'>
								{latestEvents[i].title}
							</a>
						</li>
					);
				}
			}
			if (eventsList.length === 0) {
				return ([
					<li
						key='none'
						data-value='none'
					/>
				]);
			}
			return eventsList;
		} else if (view === 'poi') {
			const poiList = [];
			const { pois } = poiStore.stateSnapshot;
			for (let i = 0; i < 3; i++) {
				let styleNamePoI = '';
				if (poi.id === pois[i].id) {
					styleNamePoI = 'selected';
				}
				poiList.push(
					<li
						key={pois[i].id}
						className={styleNamePoI}
						data-value={pois[i].external_id.replace('eo_', '')}
						onClick={this._handlePoISelection}
					>
						<a className='list-value'>
							{pois[i].title}
						</a>
					</li>
				);
			}
			if (poiList.length === 0) {
				return ([
					<li
						key='none'
						data-value='none'
					/>
				]);
			}
			return poiList;
		} else if (view === 'gmap') {
			const gmapList = [];
			const { gmaps } = gmapStore.stateSnapshot;
			for (let i = 0; i < 3; i++) {
				let styleNameGmap = '';
				if (gmap.id === gmaps[i].id) {
					styleNameGmap = 'selected';
				}
				gmapList.push(
					<li
						key={gmaps[i].id}
						className={styleNameGmap}
						data-value={gmaps[i].external_id.replace('eo_', '')}
						onClick={this._handleGmapSelection}
					>
						<a className='list-value'>
							{gmaps[i].title}
						</a>
					</li>
				);
			}
			if (gmapList.length === 0) {
				return ([
					<li
						key='none'
						data-value='none'
					/>
				]);
			}
			return gmapList;
		}
	}

	_handleEventSelection(event) {
		const { get } = refsStore.stateSnapshot;
		const eventId = event?.currentTarget?.dataset?.value;
		if (eventId) {
			get('route').goToEvent(eventId);
		}
	}

	_handlePoISelection(poi) {
		const { get } = refsStore.stateSnapshot;
		const poiId = poi?.currentTarget?.dataset?.value;
		if (poiId) {
			get('route').goToPoI(poiId);
		}
	}

	_handleGmapSelection(gmap) {
		const { get } = refsStore.stateSnapshot;
		const gmapId = gmap?.currentTarget?.dataset?.value;
		if (gmapId) {
			get('route').goToGmap(gmapId);
		}
	}

	getRelatedVSList(missionName) {
		const { vitalSignsListRef } = this.props;
		const relatedDatasets = [];
		vitalSignsListRef.map(element => {
			for (let i = 0; i < element.dataset_groupings.length; i++) {
				for (let j = 0; j < element.dataset_groupings[i].datasets_sorted[0].missions.length; j++) {
					if (element.dataset_groupings[i].datasets_sorted[0].missions[j].external_id === missionName) {
						const dsGrouping = element.dataset_groupings[i];
						dsGrouping.vitalSign = element.value;
						dsGrouping.altid = i;
						dsGrouping.titleIndex = j;
						relatedDatasets.push(dsGrouping);
						break;
					}
				}
			}
		});
		return relatedDatasets;
	}

	getRelatedDatasetsList(missionId) {
		const { get } = refsStore.stateSnapshot;
		const { vitalList } = get('content');


		const relatedDatasets = [];
		vitalList.forEach(vitalData => {
			vitalData.datasetGroups.forEach((group, altid) => {
				const { missionIds, externalId } = group.datasets[0];

				if (missionIds.includes(missionId)) {
					// { id, vitalSignId, altid, title }
					relatedDatasets.push({
						vitalSignId: vitalData.value,
						datasetId: externalId,
						title: group.title,
						altid
					});
				}
			});
		});

		return relatedDatasets;
	}

	scrollToItem(index) {
		this._footer.current.scrollToItem(index);
	}

	render() {
		const { view } = this.props;
		let footerTitle = '';

		if (view === 'spacecraft') {
			footerTitle = (
				<div className='title'>
					<div>
						{' '}
						{this.language.datasets.toUpperCase()}
						{' '}
					</div>
				</div>
			);
		} else if (view === 'event') {
			footerTitle = (
				<div className='title'>
					<div>
						{' '}
						{this.language.more_like.toUpperCase()}
						{' '}
					</div>
				</div>
			);
		} else if (view === 'poi') {
			footerTitle = (
				<div className='title'>
					<div>
						{' '}
						{this.language.more_like.toUpperCase()}
						{' '}
					</div>
				</div>
			);
		} else if (view === 'gmap') {
			footerTitle = (
				<div className='title'>
					<div>
						{' '}
						{this.language.more_like.toUpperCase()}
						{' '}
					</div>
				</div>
			);
		}

		return (
			<div id='vital-signs'>
				{footerTitle}
				<FooterNav
					content={this._renderItems()}
					ref={this._footer}
				/>
			</div>
		);
	}
}

export default VitalSigns;
